/* eslint-disable no-param-reassign */

import { FundOwnershipDetail } from 'common/types/fundOwnership';
import { IScalarSpreadsheetConfig } from 'models/interfaces/spreadsheet-types/core-types';
import { CashDistributionLedgerAcquisition, CashDistributionLedgerCell } from 'pages/CapTable/fund-ownership/components/cash-distribution/CashDistributionLedger.props';


const updateAcquisitionInColumnCells = ({
  fundOwnershipDetails,
  reverseParsedAcquisitions,
  cell,
  startingAcquisitions,
  deletedAcquisitions,
}: {
  fundOwnershipDetails: FundOwnershipDetail[];
  reverseParsedAcquisitions: CashDistributionLedgerAcquisition[];
  cell: CashDistributionLedgerCell;
  startingAcquisitions: CashDistributionLedgerAcquisition[];
  deletedAcquisitions: number[];
}) => {
  // recover ids for objects
  const currentFod = fundOwnershipDetails.find(({ columnRef }) => columnRef === cell.columnRef);
  const updatedAcquisitions: CashDistributionLedgerAcquisition[] = reverseParsedAcquisitions.map(acquisition => ({
    ...acquisition,
    id: startingAcquisitions.find(acq => acq.acquisition_ref === acquisition.acquisition_ref)?.id ?? 0,
    fund_ownership_detail: currentFod?.id ? currentFod.id : undefined,
  }) as unknown as CashDistributionLedgerAcquisition);
  // this should update the acquisitions information for the whole column
  const { columnLegend: currentColumnLegend, sheet } = cell as unknown as {
    columnLegend: string;
    sheet: IScalarSpreadsheetConfig & { cells: Record<string, CashDistributionLedgerCell> };
  };

  Object.values(sheet.cells)
    .filter(({ columnLegend }) => currentColumnLegend === columnLegend)
    .forEach((cell) => {
      cell.acquisitions = updatedAcquisitions;
      cell.deleted_acquisitions = deletedAcquisitions;
    });
};

export default updateAcquisitionInColumnCells;
